import styled from 'styled-components';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getWebFirstDepth } from '../../../api/services/systemService';
import SliderView from '../../../components/SliderView';
import CategoryCard from '../../../components/CategoryCard';

const SectionContainer = styled.section`
  margin: 0 auto;
  padding: 20px;
  width: 90%;
`;

export default function ShopByCategoryView() {
  const [categoryList, setCategoryList] = useState([]);
  const userInfo = useSelector((state) => state.userInfo);

  useEffect(() => {
    const fetchWebFirstDepth = async () => {
      try {
        const result = await getWebFirstDepth(userInfo.userId);

        if (result.categoryList && Array.isArray(result.categoryList)) {
          // Shop By Brand 는 이 섹션에서 제외
          setCategoryList(
            result.categoryList.filter(
              (category) =>
                String(category.cateNm).trim().toLowerCase() !==
                'shop by brand',
            ),
          );
        }
      } catch (error) {
        console.error('Error fetching web first depth:', error);
      }
    };

    fetchWebFirstDepth();
    // 로그인/로그아웃 시 재로드 (webuser 별 숨김 반영)
  }, [userInfo.userId]);

  // 보여줄 카테고리가 없으면 섹션(타이틀 포함) 자체를 렌더링하지 않음
  if (categoryList.length === 0) {
    return null;
  }

  return (
    <SectionContainer>
      {categoryList.length > 0 ? (
        <SliderView title={'Shop By Category'}>
          {categoryList.map((category, index) => {
            const imageUrl = `${process.env.REACT_APP_FILE_UPLOAD_URL}${category.banner_filepath1}`;

            return (
              <div key={`category_${index}`}>
                <CategoryCard
                  data={{
                    id: category.banner_filepath1,
                    name: category.cateNm,
                    image: imageUrl,
                  }}
                  key={`category_${index}`}
                />
              </div>
            );
          })}
        </SliderView>
      ) : null}
    </SectionContainer>
  );
}
